window.rankingPanelData = function () {
    return {
        rankingUsers: [],
        liveMatches: [],
        // Mon match en cours, tenu à jour par le noyau sidebar (cf. /notifications).
        activeMatch: null,
        // Paris rapides V/N/D sur les matchs en cours (cotes fournies par
        // /ranking/available-users, clé `bet` de chaque match).
        betSelection: {},
        betMessages: {},
        // Camp dont la rangée d'écarts de buts est dépliée, par match (betKey).
        betMarginsOpen: {},
        betPending: false,
        tournamentMatches: [],
        kings: [],
        loading: false,
        myRanking: parseInt((document.querySelector('meta[name="master-ranking"]') || {}).content, 10) || 1000,
        rankingActive: ((document.querySelector('meta[name="ranking-status"]') || {}).content || 'off') !== 'off',
        availabilityMode: ((document.querySelector('meta[name="ranking-availability-mode"]') || {}).content || 'all'),
        ldmEligible: ((document.querySelector('meta[name="ranking-ldm-eligible"]') || {}).content || '0') === '1',
        togglingRanking: false,
        fumaFriendly: ((document.querySelector('meta[name="fuma-friendly"]') || {}).content || '0') === '1',
        hideFuto: ((document.querySelector('meta[name="hide-futo"]') || {}).content || '0') === '1',
        hideFuma: ((document.querySelector('meta[name="hide-fuma"]') || {}).content || '0') === '1',
        myPA: ((document.querySelector('meta[name="pass-assistance"]') || {}).content || ''),
        pollInterval: null,
        initialized: false,
        activeMatchPopupShown: false,

        init() {
            let self = this;

            window.addEventListener('ranking-panel-opened', function () {
                if (!self.initialized) {
                    self.initialized = true;
                    self.fetchRankingUsers();
                    self.startPolling();
                }
            });

            window.addEventListener('ranking-status-changed', function (e) {
                self.rankingActive = e.detail.status !== 'off';
            });

            // Portée de dispo changée ailleurs (sidebar, popup d'arrivée sur le Ranking).
            window.addEventListener('ranking-availability-mode-changed', function (e) {
                if (e.detail && e.detail.mode) self.availabilityMode = e.detail.mode;
            });

            window.addEventListener('ranking-active-match', function (e) {
                self.showActiveMatchPopup(e.detail);
            });

            // Mon match ranking en cours (défi authentique, défi LDM, King) : affiché
            // en tête du panneau tant qu'il dure, popup fermé ou non.
            window.addEventListener('ranking-active-match-state', function (e) {
                self.activeMatch = e.detail || null;
            });

            window.addEventListener('sidebar-counts-updated', function (e) {
                if (e.detail && e.detail.master_ranking != null) {
                    self.myRanking = e.detail.master_ranking;
                }
                let sidebar = document.querySelector('[x-data="sidebarData()"]');
                if (sidebar && sidebar.__x) {
                    self.rankingActive = sidebar.__x.$data.rankingStatus === 'on' || sidebar.__x.$data.rankingStatus === 'live';
                }
            });
        },

        fetchRankingUsers() {
            let self = this;
            if (self.rankingUsers.length === 0) self.loading = true;

            fetch('/ranking/available-users', { cache: 'no-store' })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        self.rankingUsers = data.users;
                        self.liveMatches = data.live_matches || [];
                        self.tournamentMatches = data.tournament_matches || [];
                        self.kings = data.kings || [];
                        if (data.active_match && !self.activeMatchPopupShown) {
                            self.activeMatchPopupShown = true;
                            self.showActiveMatchPopup(data.active_match);
                        }
                    }
                    self.loading = false;
                })
                .catch(err => {
                    console.error('Ranking users error:', err);
                    self.loading = false;
                });
        },

        startPolling() {
            this.stopPolling();
            let self = this;
            this.pollInterval = setInterval(function () {
                let sidebar = document.querySelector('[x-data="sidebarData()"]');
                if (sidebar && sidebar.__x && sidebar.__x.$data.activePanel === 'ranking') {
                    self.fetchRankingUsers();
                } else {
                    self.stopPolling();
                    self.initialized = false;
                    self.activeMatchPopupShown = false;
                }
            }, 10000);
        },

        stopPolling() {
            if (this.pollInterval) {
                clearInterval(this.pollInterval);
                this.pollInterval = null;
            }
        },

        toggleRanking() {
            if (this.togglingRanking) return;
            let self = this;
            this.togglingRanking = true;
            fetch('/ranking/toggle-status', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ availability_mode: this.availabilityMode })
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        self.rankingActive = data.ranking_status !== 'off';
                        window.dispatchEvent(new CustomEvent('ranking-status-changed', { detail: { status: data.ranking_status } }));
                        if (self.rankingActive) {
                            self.fetchRankingUsers();
                            self.startPolling();
                        } else {
                            self.stopPolling();
                            self.initialized = false;
                        }
                        if (data.active_match) {
                            self.showActiveMatchPopup(data.active_match);
                        }
                    }
                })
                .catch(err => console.error('Ranking toggle error:', err))
                .finally(() => { self.togglingRanking = false; });
        },

        availabilityLabel() {
            return {
                all: 'Tous les modes',
                authentique: 'Authentique',
                ldm: 'LDM',
                dream_free: 'Dream libre',
                dream_mois: 'Dream du mois',
                // Legacy (normalisés côté serveur).
                dream_month: 'Dream du mois',
                dream: 'Dream libre'
            }[this.availabilityMode] || 'Tous les modes';
        },

        // Modes proposés au cycle : le LDM n'apparaît que si le joueur a une équipe
        // Ligue des Masters complète (sinon plus personne ne pourrait le défier).
        availabilityOrder() {
            return this.ldmEligible
                ? ['all', 'authentique', 'ldm', 'dream_free', 'dream_mois']
                : ['all', 'authentique', 'dream_free', 'dream_mois'];
        },

        cycleAvailabilityMode() {
            let order = this.availabilityOrder();
            let previous = this.availabilityMode;
            let index = order.indexOf(previous);
            this.availabilityMode = order[(index + 1) % order.length];

            let self = this;
            fetch('/ranking/availability-mode', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ availability_mode: this.availabilityMode })
            })
                .then(r => r.json())
                .then(data => {
                    // Refus serveur (ex. LDM sans équipe) : on revient au mode précédent.
                    if (!data.success) {
                        self.availabilityMode = previous;
                        if (data.message) alert(data.message);
                    } else {
                        self.fetchRankingUsers();
                    }
                })
                .catch(err => {
                    self.availabilityMode = previous;
                    console.error('availability mode error:', err);
                });
        },

        // Popup « match en cours » du Ranking. Deux familles de matchs y passent :
        //  - kind 'ranking' : match du module (authentique, Dream libre) → on peut
        //    encore l'annuler tant qu'il n'a pas démarré ;
        //  - kind 'live'    : défi LDM (épées croisées) ou match King, joué sur
        //    /matches/{id}/live → on ne propose que de le rejoindre.
        showActiveMatchPopup(match) {
            if (!match) return;

            // Déjà sur la page du match : rien à proposer.
            if (match.url && window.location.pathname === match.url.replace(/^https?:\/\/[^/]+/, '')) return;

            let key = (match.kind || 'ranking') + '-' + match.id;
            let existing = document.getElementById('ranking-active-match-popup');
            // Le panneau ranking existe en double (sidebar + dashboard) : ne pas
            // réafficher deux fois le même match.
            if (existing && existing.dataset.matchKey === key) return;
            if (existing) existing.remove();

            let esc = function (v) {
                let d = document.createElement('div');
                d.textContent = v == null ? '' : String(v);
                return d.innerHTML;
            };
            let isLive = match.kind === 'live';
            let cancelBtn = match.can_cancel
                ? '<button id="ranking-popup-cancel" class="ranking-popup-btn ranking-popup-btn--cancel"><span class="material-icons">close</span> ' + window.trans('sidebar.ranking.active_match.cancel') + '</button>'
                : '';
            let label = match.label
                ? '<p class="ranking-popup-mode">' + esc(match.label) + '</p>'
                : '';

            let popup = document.createElement('div');
            popup.id = 'ranking-active-match-popup';
            popup.className = 'ranking-popup-overlay';
            popup.dataset.matchKey = key;
            popup.innerHTML =
                '<div class="ranking-popup">' +
                    '<div class="ranking-popup-header"><h3>' + window.trans('sidebar.ranking.active_match.title') + '</h3></div>' +
                    '<div class="ranking-popup-body">' +
                        '<p>' + window.trans('sidebar.ranking.active_match.body', { opponent: '<strong>' + esc(match.opponent_name) + '</strong>' }) + '</p>' +
                        label +
                    '</div>' +
                    '<div class="ranking-popup-footer">' +
                        cancelBtn +
                        '<a href="' + match.url + '" class="ranking-popup-btn ranking-popup-btn--go"><span class="material-icons">open_in_new</span> ' +
                            window.trans(isLive ? 'sidebar.ranking.active_match.join' : 'sidebar.ranking.active_match.view') + '</a>' +
                        '<button id="ranking-popup-close" class="ranking-popup-btn ranking-popup-btn--close">' + window.trans('sidebar.ranking.active_match.close') + '</button>' +
                    '</div>' +
                '</div>';
            document.body.appendChild(popup);

            let self = this;
            document.getElementById('ranking-popup-close').addEventListener('click', function () { popup.remove(); });
            popup.addEventListener('click', function (e) { if (e.target === popup) popup.remove(); });

            if (match.can_cancel) {
                document.getElementById('ranking-popup-cancel').addEventListener('click', function () {
                    fetch('/ranking/match/' + match.id + '/cancel', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        }
                    })
                        .then(r => r.json())
                        .then(data => {
                            if (data.success) popup.remove();
                        })
                        .catch(err => console.error('Cancel error:', err));
                });
            }
        },

        // Popup de confirmation avant un défi (ranking authentique ou LDM). Le défi
        // n'est envoyé qu'au clic sur « Défier » — évite les défis accidentels
        // (notamment les mis-taps sur mobile).
        openChallengeConfirm(mode, userId, userName, masterRanking, passAssistance, courtesyRating, fumaFriendly) {
            let existing = document.getElementById('ranking-challenge-confirm-popup');
            if (existing) existing.remove();

            let self = this;
            let isLdm = mode === 'ldm';
            let popup = document.createElement('div');
            popup.id = 'ranking-challenge-confirm-popup';
            popup.className = 'ranking-popup-overlay';

            // LDM : flux dédié (équipe Ligue des Masters), sans choix de mode.
            if (isLdm) {
                popup.innerHTML =
                    '<div class="ranking-popup">' +
                        '<div class="ranking-popup-header"><h3></h3></div>' +
                        '<div class="ranking-popup-body"><p>Défiez votre adversaire avec votre équipe Ligue des Masters.</p></div>' +
                        '<div class="ranking-popup-footer">' +
                            '<button id="ranking-challenge-cancel" class="ranking-popup-btn ranking-popup-btn--close">Annuler</button>' +
                            '<button id="ranking-challenge-confirm" class="ranking-popup-btn ranking-popup-btn--go"><span class="material-icons">sports_mma</span> Défier</button>' +
                        '</div>' +
                    '</div>';
                popup.querySelector('.ranking-popup-header h3').textContent = 'Vous défiez ' + userName + ' en LDM';
                document.body.appendChild(popup);
                let closeLdm = function () { popup.remove(); };
                document.getElementById('ranking-challenge-cancel').addEventListener('click', closeLdm);
                popup.addEventListener('click', function (e) { if (e.target === popup) closeLdm(); });
                document.getElementById('ranking-challenge-confirm').addEventListener('click', function () {
                    closeLdm();
                    self.challengeLdm(userId, userName, masterRanking, courtesyRating, passAssistance, fumaFriendly);
                });
                return;
            }

            // Ranking authentique / dream : choix du mode dans le popup.
            let modes = [
                { v: 'authentique', label: 'Authentique', desc: 'Vrais clubs, contrainte de division.' },
                { v: 'dream_free', label: 'Dream libre', desc: 'Équipe montée dans le jeu, note collective libre.' },
                { v: 'dream_mois', label: 'Dream — thème du mois', desc: 'Composition selon le thème du mois.' },
                { v: 'gambardella', label: 'Gambardella (-22 ans)', desc: 'Effectifs de moins de 22 ans, 2 matchs par semaine.' },
                { v: 'peu_importe', label: 'Peu importe', desc: 'L\'adversaire choisira le mode en acceptant.' }
            ];
            // Ne proposer que les modes acceptés par l'adversaire (sa portée de dispo).
            // « Peu importe » n'a de sens que s'il lui reste au moins deux choix — la
            // Gambardella en est exclue : l'acceptation d'un défi indécis ne sait résoudre
            // que authentique / dream, et ce mode suppose un effectif de jeunes des deux
            // côtés (le serveur le renvoie dans accepted_modes seulement dans ce cas).
            let opponent = this.rankingUsers.find(function (u) { return u.id === userId; });
            let accepted = opponent && opponent.accepted_modes ? opponent.accepted_modes : null;
            if (accepted) {
                let undecidable = accepted.filter(function (m) { return m !== 'gambardella'; });
                modes = modes.filter(function (m) {
                    return m.v === 'peu_importe' ? undecidable.length > 1 : accepted.indexOf(m.v) !== -1;
                });
            }
            if (modes.length === 0) return;

            let preferred = (mode === 'dream') ? 'dream_free' : 'authentique';
            let selected = modes.some(function (m) { return m.v === preferred; }) ? preferred : modes[0].v;
            let optionsHtml = modes.map(function (m) {
                let checked = m.v === selected ? ' checked' : '';
                return '<label class="ranking-mode-option">' +
                    '<input type="radio" name="chmode" value="' + m.v + '"' + checked + '>' +
                    '<span class="ranking-mode-text"><strong></strong><small></small></span>' +
                    '</label>';
            }).join('');

            popup.innerHTML =
                '<div class="ranking-popup">' +
                    '<div class="ranking-popup-header"><h3></h3></div>' +
                    '<div class="ranking-popup-body">' +
                        '<div class="ranking-mode-options">' + optionsHtml + '</div>' +
                    '</div>' +
                    '<div class="ranking-popup-footer">' +
                        '<button id="ranking-challenge-cancel" class="ranking-popup-btn ranking-popup-btn--close">Annuler</button>' +
                        '<button id="ranking-challenge-confirm" class="ranking-popup-btn ranking-popup-btn--go"><span class="material-icons">sports_mma</span> Défier</button>' +
                    '</div>' +
                '</div>';
            popup.querySelector('.ranking-popup-header h3').textContent = 'Vous défiez ' + userName;
            // textContent pour les libellés (pas d'injection HTML).
            let labels = popup.querySelectorAll('.ranking-mode-option');
            labels.forEach(function (labelEl, i) {
                labelEl.querySelector('strong').textContent = modes[i].label;
                labelEl.querySelector('small').textContent = modes[i].desc;
            });
            document.body.appendChild(popup);

            let close = function () { popup.remove(); };
            document.getElementById('ranking-challenge-cancel').addEventListener('click', close);
            popup.addEventListener('click', function (e) { if (e.target === popup) close(); });
            document.getElementById('ranking-challenge-confirm').addEventListener('click', function () {
                let chosen = popup.querySelector('input[name="chmode"]:checked');
                let chosenMode = chosen ? chosen.value : 'authentique';
                close();
                self.challengeUser(userId, userName, masterRanking, passAssistance, courtesyRating, fumaFriendly, false, chosenMode);
            });
        },

        challengeUser(userId, userName, masterRanking, passAssistance, courtesyRating, fumaFriendly, isFriendly, mode) {
            isFriendly = !!isFriendly;
            // mode : 'authentique' | 'dream_free' | 'dream_mois' | 'peu_importe' (undefined pour l'amical).
            let isDream = typeof mode === 'string' && mode.indexOf('dream') === 0;
            let body = { opponent_id: userId, is_friendly: isFriendly };
            if (mode) body.mode = mode;
            fetch('/ranking/challenge', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify(body)
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        window.dispatchEvent(new CustomEvent('ranking-invitation-sent', {
                            detail: {
                                rankingMatchId: data.ranking_match_id,
                                isFriendly: isFriendly,
                                isDream: isDream,
                                mode: mode || null,
                                opponent: { name: userName, master_ranking: masterRanking, pass_assistance: passAssistance, courtesy_rating: courtesyRating, fuma_friendly: fumaFriendly }
                            }
                        }));
                    } else {
                        alert(data.message || 'Erreur lors du défi.');
                    }
                })
                .catch(err => console.error('Challenge error:', err));
        },

        challengeLdm(userId, userName, masterRanking, courtesyRating, passAssistance, fumaFriendly) {
            // Défi "équipe LDM" : on réutilise le flux Dream existant (live classique).
            // À l'acceptation, la modale globale redirige vers /matches/{id}/live.
            fetch('/notifications/invite-ranking-match', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ opponent_id: userId })
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        window.dispatchEvent(new CustomEvent('match-invitation-sent', {
                            detail: {
                                matchId: data.match_id,
                                opponent: { name: userName, master_ranking: masterRanking, courtesy_rating: courtesyRating, pass_assistance: passAssistance, fuma_friendly: fumaFriendly }
                            }
                        }));
                    } else {
                        alert(data.message || 'Erreur lors du défi LDM.');
                    }
                })
                .catch(err => console.error('LDM challenge error:', err));
        },

        toggleFumaFriendly() {
            let self = this;
            fetch('/ranking/toggle-fuma-friendly', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        self.fumaFriendly = data.fuma_friendly;
                        // Exclusif avec « masquer les FUMA » : le serveur peut l'avoir désactivé.
                        self.hideFuma = data.hide_fuma;
                        // Le FF défait le masquage des FUMA : la visibilité change.
                        self.fetchRankingUsers();
                    }
                })
                .catch(err => console.error('FUMA friendly toggle error:', err));
        },

        toggleHideFuto() {
            let self = this;
            fetch('/ranking/toggle-hide-futo', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        self.hideFuto = data.hide_futo;
                        // Rafraîchir la liste : le masquage mutuel change la visibilité.
                        self.fetchRankingUsers();
                    }
                })
                .catch(err => console.error('Hide FUTO toggle error:', err));
        },

        // Pendant symétrique côté joueurs auto (FUTO) : masquer les FUMA.
        toggleHideFuma() {
            let self = this;
            fetch('/ranking/toggle-hide-fuma', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
                .then(r => r.json())
                .then(data => {
                    if (data.success) {
                        self.hideFuma = data.hide_fuma;
                        // Exclusif avec FF : le serveur peut l'avoir désactivé.
                        self.fumaFriendly = data.fuma_friendly;
                        self.fetchRankingUsers();
                    }
                })
                .catch(err => console.error('Hide FUMA toggle error:', err));
        },

        // Mode « Les Kings » : revendiquer un trône libre / défier le roi depuis la sidebar.
        // Confirmation obligatoire pour éviter les clics accidentels.
        claimThrone(throneId) {
            if (!confirm('Revendiquer ce trône ? Tu deviendras roi et devras défendre ta couronne (matchs avec ton équipe Ligue des Masters).')) return;
            this.kingAction('/ranking/king/throne/' + throneId + '/claim');
        },

        challengeThrone(throneId) {
            if (!confirm('Défier le roi de ce trône ? Le match se jouera avec ton équipe Ligue des Masters.')) return;
            this.kingAction('/ranking/king/throne/' + throneId + '/challenge');
        },

        kingAction(url) {
            let self = this;
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
                .then(r => r.json())
                .then(data => {
                    if (data.message) alert(data.message);
                    self.fetchRankingUsers();
                })
                .catch(err => console.error('King action error:', err));
        },

        getCourtesyLabel(rating) {
            // Aligné sur User::getCourtesyGradeAttribute (échelle 1-12).
            const labels = { 1:'F', 2:'E-', 3:'E', 4:'D', 5:'D+', 6:'C', 7:'C+', 8:'B', 9:'B+', 10:'A', 11:'A+', 12:'S' };
            return labels[rating] || 'C';
        },

        // --- Paris V/N/D sur les matchs en cours ------------------------------------
        // Même logique que le panneau « Jeu » ; `match.kind` route vers le bon
        // marché (match de compétition ou match du module Ranking).

        /** Clé de sélection d'un pari : un match ranking et un match de compétition
         *  peuvent porter le même id, la famille (`kind`) les sépare. */
        betKey(match) {
            return (match.kind || 'match') + '-' + match.id;
        },

        get betStakes() {
            return window.matchBetting.stakes;
        },

        betLabel(outcome) {
            return window.matchBetting.outcomeLabel(outcome);
        },

        betSide(outcome) {
            return window.matchBetting.sideOf(outcome);
        },

        /** Entrée de cote d'une issue (V/N/D ou écart `home+2`) dans la quote du match. */
        betEntry(match, outcome) {
            return window.matchBetting.entryFor(match.bet, outcome);
        },

        /** Écarts de buts proposés à un camp. */
        betMargins(match, side) {
            return window.matchBetting.marginsFor(match.bet, side);
        },

        betMarginCaption(match, side) {
            const name = side === 'home' ? match.home_user : match.away_user;
            return window.matchBetting.t('bets.margin_caption', { name: name || (side === 'home' ? 'Domicile' : 'Extérieur') });
        },

        toggleBetMargins(match, side) {
            const key = this.betKey(match);
            this.betMarginsOpen[key] = this.betMarginsOpen[key] === side ? null : side;
            // Une sélection V/N/D ou un écart de l'autre camp n'a plus de sens ici.
            const selected = this.betSelection[key];
            if (selected && window.matchBetting.parseOutcome(selected).side !== this.betMarginsOpen[key]) {
                this.betSelection[key] = null;
            }
            delete this.betMessages[key];
        },

        betTitle(match, outcome) {
            const parsed = window.matchBetting.parseOutcome(outcome);
            const names = { home: match.home_user, draw: 'Match nul', away: match.away_user };
            const name = (names[parsed.side] || '?') + (parsed.margin ? ' +' + parsed.margin : '');
            const book = this.betEntry(match, outcome)?.bookmaker;
            if (!this.betBettable(match, outcome)) return name + ' — ' + window.matchBetting.t('bets.too_short');
            return name + (book ? ' — ' + book : '');
        },

        betBettable(match, outcome) {
            return window.matchBetting.isBettable(this.betEntry(match, outcome));
        },

        betStakeAllowed(match, stake) {
            const outcome = this.betSelection[this.betKey(match)];
            return window.matchBetting.stakeAllowed(stake, this.betEntry(match, outcome)?.odds, match.bet?.max_return);
        },

        formatGp(amount) {
            return window.matchBetting.formatGp(amount);
        },

        shortGp(amount) {
            return window.matchBetting.shortGp(amount);
        },

        selectBetOutcome(matchId, outcome) {
            this.betSelection[matchId] = this.betSelection[matchId] === outcome ? null : outcome;
            // Un V/N/D simple referme la rangée d'écarts.
            if (this.betSelection[matchId] && !window.matchBetting.parseOutcome(outcome).margin) {
                this.betMarginsOpen[matchId] = null;
            }
            delete this.betMessages[matchId];
        },

        placeBet(match, stake) {
            const outcome = this.betSelection[this.betKey(match)];
            if (!outcome || this.betPending) return;

            this.betPending = true;
            const oddsSeen = this.betEntry(match, outcome)?.odds;

            window.matchBetting.place(match.id, outcome, stake, oddsSeen, match.kind)
                .then(data => {
                    this.betPending = false;
                    this.betMessages[this.betKey(match)] = { text: data.message, type: data.success ? 'success' : 'error' };
                    if (data.success) {
                        this.betSelection[this.betKey(match)] = null;
                        this.betMarginsOpen[this.betKey(match)] = null;
                        match.bet = data.quote;
                    } else if (data.odds_changed) {
                        match.bet.odds = data.odds;
                        if (data.margins) match.bet.margins = data.margins;
                    }
                })
                .catch(err => {
                    this.betPending = false;
                    this.betMessages[this.betKey(match)] = { text: 'Pari impossible pour le moment.', type: 'error' };
                    console.error(err);
                });
        },

        getLiveMatchStatusLabel(status) {
            const labels = { 'in_progress':'1ère MT', 'half_time':'Mi-temps', 'second_half':'2ème MT' };
            return labels[status] || 'En cours';
        },

        startMatchmaking() {
            if (typeof window.startRankingMatchmaking === 'function') window.startRankingMatchmaking();
        }
    };
};
